import { createSelector } from 'reselect';

const getRow = (
  pageRows,
  pageModules,
  pageRowId,
  marked,
  pure,
  selectedPageModuleId
) => {
  const pageRow = pageRows[pageRowId];
  if (pure) {
    return {
      ...pageRow,
      marked,
      pageModules: pageRow.pageModules
        .filter(
          pageModuleId => pageModules[pageModuleId] && pageModuleId !== 'drag'
        )
        .map(pageModuleId => ({
          ...pageModules[pageModuleId],
          selected: pageModuleId === selectedPageModuleId
        }))
    };
  }
  return {
    ...pageRow,
    marked,
    pageModules: pageRow.pageModules
      .filter(pageModuleId => pageModules[pageModuleId])
      .map(pageModuleId => ({
        ...pageModules[pageModuleId],
        selected: pageModuleId === selectedPageModuleId
      }))
  };
};

const makeGetLayout = (pure = false) => {
  return createSelector(
    state => state.entities.page,
    state => state.result,
    state => state.entities.pageRows,
    state => state.entities.pageModules,
    state => state.overRow,
    state => state.selectedPageModuleId,
    (page, pageId, pageRows, pageModules, overRow, selectedPageModuleId) => {
      if (!pageId) {
        return {
          pageRows: []
        };
      }
      return {
        pageRows: page[pageId].pageRows
          .filter(pageRowId => pageRows[pageRowId].pageModules.length > 0)
          .map(pageRowId =>
            getRow(
              pageRows,
              pageModules,
              pageRowId,
              overRow && overRow.id === pageRowId ? overRow.position : null,
              pure,
              selectedPageModuleId
            )
          )
      };
    }
  );
};

export const getLayout = makeGetLayout();
export const getPureLayout = makeGetLayout(true);



// WEBPACK FOOTER //
// ./src/js/selectors/pageLayout.js